export default __webpack_public_path__ + "static/dima-08d530cec72bc7200d786480c8ce1a9d.png";